import { InjectionToken } from '@angular/core';

/**
 * Token used for providing the IBackButtonModuleConfig
 * @example
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: BackButtonModuleConfigToken, useValue: backButtonModuleConfig },
 * ],
 */
const BackButtonModuleConfigToken = new InjectionToken('back_button_module_config');

/**
 * Generated bundle index. Do not edit.
 */

export { BackButtonModuleConfigToken };


//# sourceMappingURL=mt-ng2-back-button-module-config.js.map